import React, {FunctionComponent, useEffect, useRef} from 'react'
import styles from './TaskList.module.sass'
import {useDispatch} from 'react-redux'
import {RootActions} from '../../../../redux/root'
import {Dispatch} from 'redux'
import RequestTaskRow from './RequestTaskRow/RequestTaskRow'
import * as A from 'fp-ts/es6/Array'
import {PERMISSIONS} from '../../../../constants/permissions'
import {useNavigation, useRootSelector} from '../../../../utils/hooks'
import {pick} from '../../../../utils/utils'
import UserTasks from '../../../data-components/UserTasks/UserTasks'
import Masonry from 'react-masonry-css'
import {taskListActions} from '../../../../redux/pages/task-list/task-list-actions'
import Helmet from 'react-helmet'
import {taskActions} from '../../../../redux/data/task/task-actions'
import {RequestStatus} from '../../../../responses/response'
import TopBarProgress from 'react-topbar-progress-indicator'
import {getId} from '../../../../utils/entity-utils'
import TaskFilters from './TaskFilters/TaskFilters'
import {DepartmentTasksFilters, TaskFiltersState} from '../../../../redux/pages/task-list/TaskFilters'
import memoize from 'memoize-one'

import NotFound from '../../../etc/NotFound/NotFound'


const breakpoints = {
    default: 4,
    2000: 3,
    1400: 2,
    1000: 1,
}

const filterSelector = memoize((filters: TaskFiltersState): DepartmentTasksFilters => ({
    department: filters.department.map(getId),
    direction: filters.direction.map(getId),
    user: filters.user.map(getId),
    client: filters.client.map(getId),
    brand: filters.brand.map(getId),
    work_object: filters.work_object.map(getId),
    tasks_type: filters.tasks_type.map(getId)
}))

const TaskList: FunctionComponent = () => {
    const dispatch = useDispatch<Dispatch<RootActions>>()
    const filters = useRootSelector(state => filterSelector(state.pages.taskFilters))

    const isFiltersActive = (filters.direction && filters.direction.length != 0) ||
        (filters.department && filters.department.length != 0) ||
        (filters.user && filters.user.length != 0) ||
        (filters.client && filters.client.length != 0) ||
        (filters.brand && filters.brand.length != 0) ||
        (filters.work_object && filters.work_object.length != 0) ||
        (filters.tasks_type && filters.tasks_type.length != 0)

    const requestedPermission = useRootSelector(
        state => !!state.global.user.data?.permissions.includes(PERMISSIONS.TASK.VIEW_REQUESTED)
    )

    const inTaskRequest = useRootSelector(
        state => state.global.user.data?.permissions.includes(PERMISSIONS.TASK.VIEW_REQUESTED)
    )

    const {departments, tasks, status} = useRootSelector(state =>
        pick(state.pages.taskList, 'departments', 'tasks', 'status')
    )

    useEffect(() => {
        requestedPermission && dispatch(taskActions.requested.request())
    }, [dispatch, requestedPermission])

    useEffect(() => {
        /* Единственное, что удалость придумать ((( */
        const directionLS: any = window.localStorage.getItem('TF_direction') ? // eslint-disable-line
            window.localStorage.getItem('TF_direction') :
            false
        if (directionLS) {
            const jsonParseDirection: any = JSON.parse(directionLS) // eslint-disable-line
            if (jsonParseDirection.length > 0) {
                filters.direction = jsonParseDirection.map(getId)
            }
        }

        const departmentLS: any = window.localStorage.getItem('TF_department') ? // eslint-disable-line
            window.localStorage.getItem('TF_department') :
            false
        if (departmentLS) {
            const jsonParseDepartment: any = JSON.parse(departmentLS) // eslint-disable-line
            if (jsonParseDepartment.length > 0) {
                filters.department = jsonParseDepartment.map(getId)
            }
        }

        const userLS: any = window.localStorage.getItem('TF_user') ? // eslint-disable-line
            window.localStorage.getItem('TF_user') :
            false
        if (userLS) {
            const jsonParseUser: any = JSON.parse(userLS) // eslint-disable-line
            if (jsonParseUser.length > 0) {
                filters.user = jsonParseUser.map(getId)
            }
        }

        const clientLS: any = window.localStorage.getItem('TF_client') ? // eslint-disable-line
            window.localStorage.getItem('TF_client') :
            false
        if (clientLS) {
            const jsonParseClient: any = JSON.parse(clientLS) // eslint-disable-line
            if (jsonParseClient.length > 0) {
                filters.client = jsonParseClient.map(getId)
            }
        }

        const brandLS: any = window.localStorage.getItem('TF_brand') ? // eslint-disable-line
            window.localStorage.getItem('TF_brand') :
            false
        if (brandLS) {
            const jsonParseBrand: any = JSON.parse(brandLS) // eslint-disable-line
            if (jsonParseBrand.length > 0) {
                filters.brand = jsonParseBrand.map(getId)
            }
        }

        const workObjectLS: any = window.localStorage.getItem('TF_work_object') ? // eslint-disable-line
            window.localStorage.getItem('TF_work_object') :
            false
        if (workObjectLS) {
            const jsonParseWorkObject: any = JSON.parse(workObjectLS) // eslint-disable-line
            if (jsonParseWorkObject.length > 0) {
                filters.work_object = jsonParseWorkObject.map(getId)
            }
        }

        const tasksTypeLS: any = window.localStorage.getItem('TF_tasks_type') ? // eslint-disable-line
            window.localStorage.getItem('TF_tasks_type') :
            false
        if (tasksTypeLS) {
            const jsonParseTasksTypeLS: any = JSON.parse(tasksTypeLS)// eslint-disable-line
            if (jsonParseTasksTypeLS.length > 0) {
                filters.tasks_type = jsonParseTasksTypeLS.map(getId)
            }
        }


        dispatch(taskListActions.departments.request(filters))
        return () => {
            dispatch(taskListActions.departments.cancel())
        }
    }, [dispatch, filters])

    const listRef = useRef(null)
    useNavigation(listRef)

    return <div ref={listRef} className={styles.taskList}>
        {
            status === RequestStatus.FETCHING && <TopBarProgress/>
        }
        <Helmet>
            <title>Список задач</title>
        </Helmet>
        <TaskFilters/>
        {
            inTaskRequest && A.isNonEmpty(tasks) && <div className={styles.request_group}>
                {/*<div className={styles.header}>Запросы на создание задач</div>*/}
                <div className={styles.requested}>
                    {
                        tasks.map(taskId => <RequestTaskRow
                            key={taskId}
                            taskId={taskId}
                            onChange={changes => dispatch(taskActions.update.request({
                                ...changes,
                                id: taskId,
                            }))}
                            onDelete={task => dispatch(taskActions.startDelete({
                                message: 'Подтвердите удаление задачи',
                                task,
                            }))}
                        />)
                    }
                </div>
            </div>
        }
        {
            status !== RequestStatus.FETCHING && A.isEmpty(departments) ?
                isFiltersActive ?
                    <NotFound
                        headerText='Задачи не найдены.'
                        infoText='Измените параметры фильтров вверху страницы.'
                        imageName='EMPTY_1'
                    /> :
                    <NotFound
                        headerText='Ни одной задачи в работе.'
                        infoText='Попросите руководителя поставить на вас задачку.'
                        imageName='EMPTY_2'
                    />
                :
                departments.map(department => <div key={department.id} className={styles.group}>
                    <div className={styles.header}>{department.title}</div>
                    <Masonry
                        className={styles.department}
                        columnClassName={styles.column}
                        breakpointCols={breakpoints}
                    >
                        {
                            department.users.map(user => <UserTasks
                                unread
                                key={user.id}
                                className={styles.tasks}
                                user={user}
                            />)
                        }
                    </Masonry>
                </div>)
        }
    </div>
}

TaskList.whyDidYouRender = true

export default TaskList